// firebase.ts
import { FirebaseApp, initializeApp } from "firebase/app";
import { Analytics, getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let firebaseApp: FirebaseApp | null = null;
let analytics: Analytics | null = null;

export function initializeFirebaseAnalytics(): Analytics | null {
  if (analytics) return analytics;

  try {
    // Initialize Firebase
    firebaseApp = initializeApp(firebaseConfig);
    if (firebaseConfig.measurementId) {
      analytics = getAnalytics(firebaseApp);
      console.log("Firebase Analytics initialized successfully");
    }
  } catch (e) {
    console.warn("Firebase Analytics init failed:", e);
  }

  return analytics;
}

export function getFirebaseAnalytics(): Analytics | null {
  return analytics;
}
